export { GolfPlayersContent } from './GolfPlayersContent';
export type {
  GolfPlayerConfig,
  GolfPlayersContentLabels,
  GolfPlayersContentProps,
} from './GolfPlayersContent.types';
